import { useCallback, useState } from 'react';

export const SIDEBAR_STORAGE_KEY = 'bz.sidebarCollapsed';

const read = () => {
  try {
    return window.localStorage.getItem(SIDEBAR_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

const write = (collapsed) => {
  try {
    window.localStorage.setItem(SIDEBAR_STORAGE_KEY, collapsed ? '1' : '0');
  } catch {
    /* private mode / storage disabled — keep in-memory state only */
  }
};

/**
 * Desktop sidebar collapsed state, persisted in localStorage.
 * Default (no key) is expanded.
 */
export const useSidebarCollapsed = () => {
  const [collapsed, setCollapsedState] = useState(read);

  const setCollapsed = useCallback((value) => {
    setCollapsedState((prev) => {
      const next = typeof value === 'function' ? value(prev) : !!value;
      write(next);
      return next;
    });
  }, []);

  const toggle = useCallback(() => setCollapsed((prev) => !prev), [setCollapsed]);

  return { collapsed, setCollapsed, toggle };
};

export default useSidebarCollapsed;
